import type { Question, SurveyModel } from 'survey-core';

export function surveyQuestionLabel(question: Question): string {
  const locTitle = question.locTitle?.text || question.title;
  const plain =
    typeof locTitle === 'string'
      ? locTitle.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
      : '';
  return plain || question.name;
}

/** Kører validering på alle synlige sider og hopper til første side med fejl. */
export function validateEntireSurvey(model: SurveyModel): boolean {
  let allValid = true;
  let firstInvalidPage: (typeof model.visiblePages)[number] | undefined;

  for (const page of model.visiblePages) {
    if (!page.validate(true, false)) {
      allValid = false;
      if (!firstInvalidPage) {
        firstInvalidPage = page;
      }
    }
  }

  if (firstInvalidPage) {
    model.currentPage = firstInvalidPage;
    firstInvalidPage.validate(true, true);
  }

  return allValid;
}

export function collectSurveyValidationErrors(model: SurveyModel): string[] {
  const labels: string[] = [];
  const seen = new Set<string>();

  for (const question of model.getAllQuestions(true, false, true)) {
    if (!question.errors?.length) {
      continue;
    }
    const label = surveyQuestionLabel(question);
    const key = `${question.name}:${label}`;
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    labels.push(label);
  }

  return labels;
}

export function formatMissingFieldsMessage(
  fieldLabels: string[],
  maxListed = 6
): string {
  if (!fieldLabels.length) {
    return 'Udfyld venligst alle obligatoriske felter';
  }
  const listed = fieldLabels.slice(0, maxListed);
  const rest = fieldLabels.length - listed.length;
  let msg = `Manglende felter: ${listed.join(', ')}`;
  if (rest > 0) {
    msg += ` (og ${rest} mere)`;
  }
  return msg;
}
